import React from 'react';
import { useLocation } from 'react-router-dom';
import './ResultsPage.css';

const ResultsPage = () => {
  const location = useLocation();
  const { results } = location.state || { results: [] };

  return (
    <div className="results-container">
      <div className="card">
        <h5 className="card-title">Results</h5>
        <div className="results-table-container">
          {results.length > 0 ? (
            <table className="table results-table">
              <thead>
                <tr>
                  {Object.keys(results[0]).map((key) => (
                    <th key={key}>{key}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {results.map((row, index) => (
                  <tr key={index}>
                    {Object.values(row).map((value, i) => (
                      <td key={i}>
                        {/*{typeof value === 'object' ? JSON.stringify(value) : value}</td>*/}
                        {value === null || value === undefined || (typeof value === 'object' && Object.keys(value).length === 0)
                          ? ''
                          : typeof value === 'object'
                            ? JSON.stringify(value)
                            : value}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No results found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResultsPage;
